import { LatLngBounds } from 'leaflet';

/**
 * Calculate map zoom level based on area in hectares
 * Shows 4 hectares square (2x area) centered on coordinates
 * Default: 5 hectares if area is missing
 */
export const calculateMapZoom = (area: number | null | undefined): number => {
  const areaInHectares = area || 5; // Default to 5 hectares
  const displayArea = areaInHectares * 2; // Show 2x area (4 hectares square if area is 2)
  
  // Approximate zoom levels based on area
  // These are rough estimates - Leaflet will adjust automatically with bounds
  if (displayArea >= 100) return 10;
  if (displayArea >= 50) return 11;
  if (displayArea >= 20) return 12;
  if (displayArea >= 10) return 13;
  if (displayArea >= 5) return 14;
  if (displayArea >= 2) return 15;
  return 16;
};

/**
 * Calculate map bounds for a square area centered on coordinates
 * @param lat Latitude
 * @param lng Longitude
 * @param area Area in hectares
 * @returns Leaflet bounds object
 */
export const calculateMapBounds = (
  lat: number,
  lng: number,
  area: number | null | undefined
): LatLngBounds => {
  const areaInHectares = area || 5; // Default to 5 hectares
  const displayArea = areaInHectares * 2; // Show 2x area
  
  // Convert hectares to approximate degrees
  // 1 hectare ≈ 0.01 km²
  // At equator: 1 degree ≈ 111 km
  // So 1 hectare ≈ 0.00009 degrees
  const degreesPerHectare = 0.00009;
  const halfSize = Math.sqrt(displayArea) * degreesPerHectare / 2;
  
  return new LatLngBounds(
    [lat - halfSize, lng - halfSize],
    [lat + halfSize, lng + halfSize]
  );
};

/**
 * Generate Google Maps URL for opening location in new tab
 */
export const getGoogleMapsUrl = (lat: number, lng: number): string => {
  return `https://www.google.com/maps?q=${lat},${lng}`;
};

/**
 * Format coordinates for display and copying
 */
export const formatCoordinates = (lat: number, lng: number): string => {
  return `${lat}, ${lng}`;
};

